'use strict';

/**
 * filtering decorator implementation for the contact-box module.
 *
 * @author Mathias Hayoz <mathias.hayoz@namics.com>
 */
T.Module.ContactBox.Filtering = T.createDecorator({
	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);
		this.$contacts = this.$ctx.find(this._selectors.countries);

		// Data
		this.activeCountries = new Map();

		// Global Event Binding
		this._events.on(this._eventNames.countryFilterChange, this.onCountryChange.bind(this));

		// Lifecycle callback
		this._parent.start(resolve);
	},


	/**
  * Handler for Country Filter change event
  * @param {string} value - value of selected option
  * @param {string} id - id of selected option
  * @returns {undefined} void
  */
	onCountryChange: function onCountryChange(value, id) {
		this.deactivateAllCountries();
		this.activateCountry(id);
		this.updateContactsDisplay();
	},
	updateContactsDisplay: function updateContactsDisplay() {
		var _this = this;

		// Hide all
		this.$contacts.removeClass(this._stateClasses.contactVisible);

		// Filter elements with matching country
		var $activeElements = this.$contacts.filter(function (index, domElem) {
			return _this.doesElemContainActiveCountry($(domElem));
		});

		// Show them
		$activeElements.addClass(this._stateClasses.contactVisible);

		window.console.log(this._stateClasses.contactVisible);
	},


	/**
  * Handler for Country Filter change event
  * @param {string} id - id of selected option in Country filter
  * @param {number} index - index of current element in iteration
  * @param {Object} value - Current element in iteration
  * @returns {undefined} void
  */
	displayContactsForCountry: function displayContactsForCountry(id, index, value) {
		var $value = $(value);

		if ($value.data('countries').indexOf(id) !== -1) {
			$value.addClass(this._stateClasses.contactVisible);
		}
	},
	activateCountry: function activateCountry(countryId) {
		this.activeCountries.set(countryId, true);
	},
	deactivateAllCountries: function deactivateAllCountries() {
		var _this2 = this;

		this.activeCountries.forEach(function (flag, countryId) {
			_this2.deactivateCountry(countryId);
		});
	},
	deactivateCountry: function deactivateCountry(countryId) {
		this.activeCountries.set(countryId, false);
	},


	/**
  * Returns true if jQuery elem has country data which is active.
  *
  * @param {jQuery} $elem - jQuery element containing data
  * @returns {boolan} - true if is in active list
  */
	doesElemContainActiveCountry: function doesElemContainActiveCountry($elem) {
		var _this3 = this;

		var isInActiveList = false;

		// Get elem data: a csv
		var elemCountryCsv = $elem.data('countries');

		// Find out if in active list
		this.activeCountries.forEach(function (flag, countryId) {
			if (flag === true && _this3._doesCsvContain(elemCountryCsv, countryId)) {
				isInActiveList = true;
			}
		});

		return isInActiveList;
	},


	/**
  * Returns true if value is part of csv.
  *
  * Attention: CSV values must not contain separator char ','
  *
  * @param {string} csv - CSV string
  * @param {string} value - value to search for
  * @returns {boolan} - true if value is part of csv
  */
	_doesCsvContain: function _doesCsvContain(csv, value) {
		var doesContain = false;

		if (!csv.length) {
			return false;
		}

		// Split csv into array
		var dataArr = csv.split(',');
		if (!$.isArray(dataArr)) {
			return false;
		}

		// Search for value in array
		if ($.inArray(value, dataArr) !== -1) {
			doesContain = true;
		}

		return doesContain;
	}
});